<template>
    <div>
        <b-card class="standardpage reports">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="3" class="text-sm-left pt-1">
                        <i :class="clients.icon" class="mr-1"></i>
                        <span>{{ clients.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">

                        <b-row v-if="!showfilter">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <span style="padding-top: 0.3em" class="text-primary"
                                            id="slaclike-tooltip">Like</span>
                                        <b-form-checkbox id="slaclike" v-model="slaclike_visible" class="z-0">
                                        </b-form-checkbox>
                                    </b-input-group>
                                    <b-input-group v-if="!slaclike_visible">
                                        <treeselect placeholder="Select slac..."
                                            searchPromptText="Type at least 3 chars..." v-model="code" :multiple="true"
                                            :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                            :show-count="true" :flatten-search-results="true"
                                            :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                            <div slot="value-label" slot-scope="{ node }">
                                                {{ node.raw.id }}
                                            </div>
                                        </treeselect>
                                    </b-input-group>
                                </b-form-group>
                                <b-input-group v-if="slaclike_visible">
                                    <b-form-input v-model="slaclike" :debounce="clients.debounce"
                                        placeholder="Client SL A/C (LIKE %)" trim></b-form-input>
                                    <b-input-group-append>
                                        <b-button size="sm" variant="outline-secondary" :disabled="!slaclike"
                                            @click="slaclike = ''">
                                            <i class="fa fa-remove"></i>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                                <!-- </b-form-group> -->
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Client Name" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="description" :debounce="clients.debounce"
                                            placeholder="Client Name"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!description"
                                                @click="description = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Active?" label-for="active" label-cols="12">
                                    <treeselect instanceId="active" type="number" v-model="active" :clearable="true"
                                        :options="active_options"></treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Credit Active?" label-for="cractive" label-cols="12">
                                    <treeselect instanceId="cractive" type="number" v-model="cractive" :clearable="true"
                                        :options="cractive_options"></treeselect>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Onstop?" label-for="onstop" label-cols="12">
                                    <treeselect instanceId="onstop" type="number" v-model="onstop" :clearable="true"
                                        :options="onstop_options"></treeselect>
                                </b-form-group>
                            </b-col>
                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="Relevance" label-size="sm">
                    <treeselect
                      id="sl-query"
                      placeholder="Relevance query..."
                      :clearable="false"
                      v-model="query"
                      :options="query_options"
                      :disable-branch-nodes="true"
                      :show-count="true"
                      :default-expand-level="1"
                    />
                  </b-form-group>
                  <b-tooltip target="sl-query1" triggers="hover"
                    >Explain query...</b-tooltip
                  >
                </b-col> -->
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Budget" label-for="budget" label-cols="12">
                                    <treeselect instanceId="budget" type="number" v-model="salesgroup" :clearable="true"
                                        :options="budget_options"></treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Account Type" label-size="sm">
                                    <treeselect placeholder="Select type..." v-model="accounttype" :clearable="true"
                                        :multiple="true" :options="accounttype_options" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested>
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Carbon Type" label-size="sm">
                                    <treeselect placeholder="Select type..." v-model="carbon_type" :clearable="true"
                                        :multiple="true" :options="carbontype_options" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested>
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.label }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3 mx-0 text-left">
                    <div v-if="clients.pastespecial">
                        <b-row class="mt-2" no-gutters>
                            <b-col cols="6">
                                <b-form-group>
                                    <b-form-checkbox-group id="segments_paste_selected" v-model="clients.paste_selected"
                                        :options="clients.paste_options" value-field="id"
                                        text-field="label"></b-form-checkbox-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="auto" class="text-right ml-auto">
                                <b-row>
                                    <!-- <b-col cols="auto">
                    <b-link squared size="sm" variant="outline-primary" @click="download()">
                      <i class="fa fa-download"></i>
                      Template
                    </b-link>
                  </b-col> -->
                                    <b-col cols="auto">
                                        <b-link size="sm" variant="outline-primary" @click="clients_creditit()">
                                            <i class="fa fa-line-chart"></i>
                                            Credit
                                        </b-link>
                                    </b-col>
                                    <b-col cols="auto">
                                        <b-link size="sm" variant="outline-primary" @click="clients_saveit()">
                                            <i class="fa fa-floppy-o"></i>
                                            Save It
                                        </b-link>
                                    </b-col>
                                    <b-col cols="auto">
                                        <b-link size="sm" variant="outline-primary" @click="clients_headers()">
                                            Headers
                                        </b-link>
                                    </b-col>
                                    <b-col cols="auto">
                                        <b-link size="sm" variant="outline-primary" @click="clients_paste_read()">
                                            <i class="fa fa-magic"></i>
                                            Read It
                                        </b-link>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label-cols="12">
                                    <b-form-textarea id="data" v-model="clients.paste" placeholder="Paste client data"
                                        rows="6" class="smalltextarea courier"></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <d-table classdivtable="availtable datatable" refid="clients" :icon="clients.icon"
                        :busy="clients.busy" :toolbarlibrary="clients.toolbarlibrary" :tools="clients.tools"
                        :badges="clients.badges" :fields="clients.fields" :items="clients.items"
                        :offset="clients.offset" :limit="clients.limit" :downloaded="clients.downloaded"
                        :page="clients.page" @load="clients_load" @click="clients_click"
                        @changed="clients_click('save', $event)" @select="clients_select">
                    </d-table>
                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="clients.selected"
                    :config="clients.action ? { action: clients.action } : {}" @discard="clients_click('discard')">
                </component>
            </div>

            <b-card-footer class="mt-2 ml-1">
                <div class="text-center">
                    <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                        <i class="fa fa-cogs mr-2"></i>Setup All
                    </b-button>
                </div>
            </b-card-footer>

        </b-card>
    </div>
</template>


<script>
import gql from "graphql-tag";

import ClientEdit from "./Components/Setup_ClientEditN";


function tabToObjArr(text) {

    let raw = text.trim().split('"').join("")
    let allcols = raw.split("\t")

    let headers = raw.split("\n")[0].split("\t")
    let cb = headers.length - 1
    let cols = []
    for (let i = 0; i < allcols.length; i++) {
        if (i == cb) {
            let parts = allcols[i].trim().split("\n")
            for (let k = 0; k < parts.length; k++) {
                cols.push(parts[k].trim())
            }
            cb += headers.length - 1
        } else {
            cols.push(allcols[i].trim().split("\n").join(",").replace(/\s+/g, ' '))
        }
    }
    console.log('cols=', cols)

    cb = headers.length - 1
    let rows = []
    let item = {}
    let k = 0
    for (let i = 0; i < cols.length; i++) {
        if (i == cb) {
            item[headers[k]] = cols[i]
            rows.push(item)
            cb += headers.length
            item = {}
            k = 0
        } else {
            item[headers[k]] = cols[i]
            k += 1
        }
    }
    return rows;
}

export default {
    name: "ClientsN",
    components: { ClientEdit },
    watch: {
        async code() {
            await this.clients_load(0);
        },
        async slaclike_visible() {
            if (this.slaclike_visisble) {
                this.code = []
            } else {
                this.slaclike = null
            }
            await this.clients_load();
        },
        async slaclike() {
            await this.clients_load();
        },
        async description() {
            await this.clients_load(0);
        },
        async salesgroup() {
            await this.clients_load(0);
        },
        async cractive() {
            await this.clients_load(0);
        },
        async onstop() {
            await this.clients_load(0);
        },
        async active() {
            await this.clients_load(0);
        },
        async accounttype() {
            await this.clients_load(0);
        },
        async carbon_type() {
            await this.clients_load(0);
        },
    },
    data() {
        return {
            code: [],
            slaclike: null,
            slaclike_visible: null,
            description: null,
            salesgroup: null,
            onstop: null,
            cractive: null,
            active: "1",
            budget_options: [],
            cractive_options: [
                {
                    id: "1",
                    label: "Yes",
                },
                {
                    id: "0",
                    label: "No",
                },
            ],
            onstop_options: [
                {
                    id: "1",
                    label: "Yes",
                },
                {
                    id: "0",
                    label: "No",
                },
            ],
            active_options: [
                {
                    id: "1",
                    label: "Yes",
                },
                {
                    id: "0",
                    label: "No",
                },
            ],
            accounttype: [],
            accounttype_options: [],
            carbon_type: [],
            carbontype_options: [{ id: "thrust", label: "Thrust Carbon" }],

            clients: {
                title: "Clients SQL",
                icon: "fa fa-handshake-o",
                debounce: 500,
                busy: false,
                denied: [],
                page: 1,
                offset: 0,
                limit: 15,
                action: null,
                pastespecial: false,
                paste: null,
                paste_selected: ["firstrowheader", "reversenamecap"],
                paste_options: [
                    { id: "firstrowheader", label: "First Row Headers", disabled: true },
                    { id: "secondrowskip", label: "Second Row Skip" },
                    { id: "filldown", label: "Fill Down" },
                ],
                tools: "go,filter,download,clipboard,add,copy,edit,pastespecial,deleteconfirm,due,email",
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-line-chart text-primary mr-1",
                        position: "toolbar",
                        action: "due",
                        label: "Due",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-envelope text-primary mr-1",
                        position: "toolbar",
                        action: "email",
                        label: "Email",
                        component: {
                            name: "",
                        },
                    },
                ],

                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right text-primary w-50px",
                    },
                    {
                        key: "code",
                        label: "SL A/C",
                        sortable: true,
                    },
                    {
                        key: "accounttype",
                        label: "A Type",
                        sortable: true,
                    },
                    {
                        key: "description",
                        label: "Name",
                        sortable: true,
                    },
                    {
                        key: "crlimit",
                        label: "Credit",
                        sortable: true,
                        class: "text-right d-none d-sm-table-cell",
                        totalled: true,
                        total: 0,
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result != "N/A") {
                                result = parseFloat(result).toLocaleString(undefined, { minimumFractionDigits: 2 })
                            }
                            return result;
                        },
                    },
                    {
                        key: "crspent",
                        label: "Due",
                        sortable: true,
                        class: "text-right d-none d-sm-table-cell",
                        totalled: true,
                        total: 0,
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                result = parseFloat(result).toLocaleString(undefined, { minimumFractionDigits: 2 })
                            }
                            return result;
                        },
                    },
                    // {
                    //     key: "progress",
                    //     label: "Progress%",
                    //     sortable: true,
                    //     class: "d-none d-xl-table-cell",
                    // },
                    {
                        key: "paymethod",
                        label: "Pay Method",
                        sortable: true,
                    },
                    {
                        key: "statementtype",
                        label: "Statement Type",
                        sortable: true,
                    },
                    {
                        key: "invoicetype",
                        label: "Invoice Type",
                        sortable: true,
                    },
                    {
                        key: "onstop",
                        label: "Onstop",
                        sortable: true,
                    },

                    {
                        key: "active",
                        label: "Active",
                        sortable: true,
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center w-100px",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-right w-100px",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [
                    {
                        key: "progress",
                        type: "progressbar",
                        class: "warning",
                    },
                    {
                        key: "accounttype",
                        type: "pill",
                        class: "info",
                    },
                    {
                        key: "paymethod",
                        type: "badge",
                        IN: "info",
                        CR: "danger",
                    },
                    {
                        key: "invoicetype",
                        type: "badge",
                        P: "info",
                        N: "danger",
                        E: "info",
                    },
                    {
                        key: "onstop",
                        type: "badge",
                        Yes: "success",
                        No: "danger",

                        formatter: (value, key, item) => {
                            if (value == '0') {
                                return "No";
                            } else if (value == '1') {
                                return "Yes";
                            } else {
                                return "";
                            }

                        },
                    },

                    {
                        key: "active",
                        type: "badge",
                        Yes: "success",
                        No: "danger",

                        formatter: (value, key, item) => {
                            switch (value) {
                                case "true":
                                    return "Yes";

                                case "false":
                                    return "No";

                                default:
                                    return value;
                            }
                        },
                    },

                ],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    async mounted() {

        await this.loadDDL();

        await this.clients_load();
    },

    methods: {
        async loadDDL() {
            console.log("loadDDL");

            try {
                const response = await this.$apollo.query({
                    query: gql`
              query setup_budgets {
                setup_budgets(isactive: true) {
                  id:description
                  label: description
                }
              }
            `,
                });
                this.budget_options = response.data.setup_budgets;
            } catch (error) {
                console.log(error);
            }

            try {
                const response = await this.$apollo.query({
                    query: gql`
              query clientaccounttypes {
                clientaccounttypes {
                  id
                  label: name
                }
              }
            `,
                });
                this.accounttype_options = [...response.data.clientaccounttypes];
                for (var j = 0; j < this.accounttype_options.length; ++j) {
                    if (!this.accounttype_options[j].label.includes("|")) {
                        this.accounttype_options[j].label =
                            this.accounttype_options[j].label +
                            " | " +
                            this.accounttype_options[j].id;
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        async clients_load(offset, limit, page) {
            let state = this.clients;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                query: this.query,
                code: this.code.length > 0 ? this.code.join(",") : null,
                slaclike: this.slaclike,
                description: this.description,
                salesgroup: this.salesgroup,
                cractive: this.cractive,
                attributes: this.attributes,
                active: this.active,
                onstop: this.onstop,
                accounttype:
                    this.accounttype.length > 0 ? this.accounttype.join(",") : null,
                carbon_type:
                    this.carbon_type.length > 0 ? this.carbon_type.join(",") : null,
                dateformat: "DD/MM/YYYY",
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
              query setup_clients(
                $limit: Int
                $offset: Int
                $query: String
                $code: String
                $description: String               
                $slaclike: String
                $salesgroup: String
                $onstop: String
                $cractive: String
                $accounttype: String
                $carbon_type: String
                $active: String                 
              ) {
                setup_clients(
                  limit: $limit
                  offset: $offset
                  query: $query
                  code: $code
                  description: $description                
                  slaclike: $slaclike
                  salesgroup: $salesgroup
                  onstop: $onstop
                  cractive: $cractive  
                  accounttype: $accounttype
                  carbon_type: $carbon_type
                  active: $active   
                ) {
                  id
                  code
                  description
                  crlimit
                  crspent                  
                  salesgroup
                  statementtype
                  invoicetype
                  paymethod
                  attributes
                  cractive
                  accounttype
                  carbon_type
                  active
                  onstop
                  updated_by
                  updated_at
                  rows
                }
              }
            `,
                    variables,
                });

                // USE LOCAL VARIABLE
                // if (limit == 0) {
                //     state.selected = response.data.clients
                // } else {
                //     state.items = []
                //     state.items = response.data.clients;
                // }

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.setup_clients
                } else {
                    state.items = []
                    state.items = response.data.setup_clients;
                }

                // this.clients.items = response.data.clients;
            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async clients_click(a, ss) {

            let state = this.clients;
            state.action = null;

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.clients_load(0, 0);
                    break;
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                case "go":
                    this.component = null;
                    this.clients_load();
                    break;
                case "add":
                case "edit":
                    this.component = "ClientEdit";
                    break;
                case "copy":
                    state.action = "copy";
                    this.component = "ClientEdit";
                    await this.clients_load(0);
                    break;
                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;

                case "due":
                    await this.clients_spent(ss);
                    break;

                case "email":
                    await this.clients_email(ss);
                    break;

                case "pastespecial":
                    state.pastespecial = !state.pastespecial
                    if (!state.pastespecial) {
                        this.clients_load();
                    }
                    break;
            }
        },
        async clients_select(ss, tools) {

            let state = this.clients;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "clipboard", "add", "pastespecial", "download", "due", "email"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["copy", "edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async clients_spent(ss) {
            let state = this.clients;

            if (await this.$bvModal.msgBoxConfirm('Clients that are credit enabled will be updated with their due balance.', {
                title: 'Please confirm you want to accumulate the spend to date?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {
                state.busy = true

                let rows = [];
                ss.forEach(function (v) {
                    rows.push({ id: v.id, code: v.code });
                });
                let variables = {
                    selected: rows,
                };
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation clients_spent ($selected: [Client_input]) {
                            clients_spent (selected: $selected) 
                        }
                        `,
                    variables,
                });

                state.busy = false
            } else {
                state.busy = false
            }

            await this.clients_load(0);
        },

        async clients_email(ss) {
            let state = this.clients;

            if (await this.$bvModal.msgBoxConfirm('Clients that are ... overspent will be emailed ...', {
                title: 'Please confirm you want to email client?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {
                state.busy = true

                let rows = [];
                ss.forEach(function (v) {
                    rows.push({ id: v.id, code: v.code });
                });
                let variables = {
                    selected: rows,
                };
                const response = await this.$apollo.query({
                    query: gql`
                        query clients_email ($selected: [Client_input]) {
                            clients_email (selected: $selected) 
                        }
                        `,
                    variables,
                });

                state.busy = false
            } else {
                state.busy = false
            }

            await this.clients_load(0);
        },

        async clients_paste_read() {

            let state = this.clients;

            if (state.paste) {
                state.busy = true
                let rows = tabToObjArr(state.paste)

                let rowstart = 1
                if (state.paste_selected.includes("secondrowskip")) {
                    rowstart += 1
                }

                // MAKE OBJECT ITEMS
                let items = []
                for (let i = rowstart; i < rows.length; i++) {
                    items.push(rows[i])
                }

                if (state.paste_selected.includes("filldown")) {
                    let lastitem = {}
                    for (let i = 0; i < items.length; i++) {
                        let item = items[i]
                        for (let prop in lastitem) {
                            if (!item[prop]) {
                                if (lastitem[prop]) {
                                    item[prop] = lastitem[prop]
                                }
                            }
                        }
                        lastitem = item
                    }
                }

                let found = null

                rows = []
                for (let i = 0; i < items.length; i++) {
                    let obj = items[i]

                    let client = {}

                    for (let prop in obj) {

                        let values = []
                        try {
                            if (obj[prop]) {
                                let data = obj[prop].trim().toUpperCase()
                                let colname = prop.toLowerCase()

                                if (colname == 'code' || colname == "sl a/c") {
                                    client.code = data
                                }

                                if (colname == 'credit') {
                                    if (!data.includes("*")) {
                                        data = data.split(",").join("").split("£").join("")
                                        console.log('data=', data)
                                        client.crlimit = parseFloat(data).toFixed(2)
                                    }
                                }

                            }

                        } catch (error) {
                            console.log('error here', error)
                        }
                    }
                    // DE-DUPLICATE
                    found = rows.find(o => o.code == client.code)
                    if (!found) {
                        if (client.crlimit != 'NaN') {
                            rows.push(client)
                        }
                    }
                }
                console.log('rows=', rows)

                state.items = rows

                state.busy = false
            }

        },
        async clients_headers() {

            let state = this.clients;

            let content = state.paste
            state.paste = "SLAC\tCreditSpent\n"
            if (content) {
                state.paste += content
            }
        },

        async clients_saveit() {
            console.log("clients_saveit");

            let state = this.clients;

            state.busy = true;

            let rows = this.cleanit(state.items)
            rows = rows.filter(obj => obj.crlimit)

            rows = rows.map(obj => ({ ...obj, cractive: '1' }))

            let variables = { rows };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation clients_save($rows: [Client_input]) {
                        clients_save(rows: $rows) {
                            id
                        }
                        }
                    `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            state.busy = false;

        },

        async saveit(ss) {

            let state = this.clients;

            state.busy = true;

            let variables = { rows: this.cleanit(state.items) };

            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation clients_save(
                $rows: [Client_input]             
              ) {
                clients_save(rows: $rows) {
                    id
                  code
                  description
                  code
                  salesgroup
                  statementtype
                  invoicetype
                  paymethod
                  attributes
                  cractive
                  accounttype
                  carbon_type
                  active
                  onstop
                }
              }
            `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            state.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation clients_delete(
                $rows: [Client_input]
              ) {
                clients_delete(rows: $rows) {
                  id
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.clients_load(0);
        },

    },
};
</script>

<style></style>